import React from 'react';
import PropTypes from 'prop-types';
import { categoryBadgeVariant } from 'data';
import { cn } from 'lib/utils';
import { Badge } from 'components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

const categoryClasses = {
  standard: 'border-[#dbe8fb] bg-[#f0f6ff] text-[#326491]',
  premium: 'border-[#f0e4c8] bg-[#fff8e8] text-[#896023]',
  diaspora: 'border-[#e9dff2] bg-[#f7f2fb] text-[#755097]',
  diaspora_2: 'border-[#f3dde4] bg-[#fff3f6] text-[#a54b61]',
  supervisor: 'border-[#d4eae2] bg-[#eff9f5] text-[#247e6e]',
  supervisor_2: 'border-[#daebf2] bg-[#eff8fc] text-[#317791]',
  other: 'border-[#d4eae2] bg-[#eff9f5] text-[#247e6e]',
};

const CategoryBadge = ({
  categoryName,
  className = '',
  tooltipClassName = '',
  recoverable = false,
  portalled = false,
}) => {
  if (!categoryName) return <span className="text-[#89958d]">-</span>;

  const categoryVariant = categoryBadgeVariant(categoryName);
  const badge = (
    <Badge
      data-category-badge
      data-category-variant={categoryVariant}
      variant="outline"
      className={cn(
        'max-w-full rounded-[5px] border px-1.5 py-0.5 text-[11.5px] font-medium leading-4',
        categoryClasses[categoryVariant],
        className
      )}
    >
      <span className={cn(recoverable && 'line-clamp-2 whitespace-normal break-words')}>{categoryName}</span>
    </Badge>
  );

  if (!recoverable) return badge;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          tabIndex={0}
          className="inline-flex max-w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2c8155]"
        >
          {badge}
        </div>
      </TooltipTrigger>
      <TooltipContent portalled={portalled} className={cn('max-w-[280px] break-words', tooltipClassName)}>
        {categoryName}
      </TooltipContent>
    </Tooltip>
  );
};

CategoryBadge.propTypes = {
  categoryName: PropTypes.string,
  className: PropTypes.string,
  tooltipClassName: PropTypes.string,
  recoverable: PropTypes.bool,
  portalled: PropTypes.bool,
};

export default CategoryBadge;
